import { ALPHABET } from '../constants/alphabet';
import { ROMAN_NUMERALS } from '../constants/roman-numerals';

export class IndentationNumerationUtil {
    public static getTextWithIndentationAndNumeration(
        //identationLevel to identify the level in the heirarchy to use ABC or IIII or 123 or abc,.....etc
        indentationLevel: number,
        //reOcurranceIndex to get the exact letter/number to use
        reOcurranceIndex: number,
        text: string,
    ): string {
        switch (indentationLevel) {
            case 1:
                return `${ALPHABET[reOcurranceIndex - 1]}. ${text}`;
            case 2:
                return `${IndentationNumerationUtil.repeatSubstring('\t', indentationLevel - 1)}${
                    ROMAN_NUMERALS[reOcurranceIndex - 1]
                }. ${text}`;
            case 3:
                return `${IndentationNumerationUtil.repeatSubstring(
                    '\t',
                    indentationLevel - 1,
                )}${reOcurranceIndex}. ${text}`;
            case 4:
                return `${IndentationNumerationUtil.repeatSubstring('\t', indentationLevel - 1)}${ALPHABET[
                    reOcurranceIndex - 1
                ].toLowerCase()}. ${text}`;
            case 5:
                return `${IndentationNumerationUtil.repeatSubstring('\t', indentationLevel - 1)}${ROMAN_NUMERALS[
                    reOcurranceIndex - 1
                ].toLowerCase()}. ${text}`;
            case 6:
                return `${IndentationNumerationUtil.repeatSubstring(
                    '\t',
                    indentationLevel - 1,
                )}${reOcurranceIndex}.${text}`;
            case 7:
                return `${IndentationNumerationUtil.repeatSubstring(
                    '\t',
                    indentationLevel - 1,
                )}${reOcurranceIndex}.${text}`;
            default:
                return `${text}`;
        }
    }

    public static repeatSubstring(substring: string, count: number): string {
        const repeatedSubstring = substring.repeat(count);
        return repeatedSubstring;
    }
}
